import { createContext, RefObject, useContext } from 'react';

export const ScrollableContainerContext =
  createContext<RefObject<HTMLElement | null> | null>(null);

export const useScrollableContainerContext = () => {
  const context = useContext(ScrollableContainerContext);

  if (!context) {
    throw new Error(
      'useScrollableContainer must be used within ScrollableContainerProvider',
    );
  }
  return context;
};
